import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import AlertModal from '../../../../shared/components/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import ModalSurveyPatients from './ModalSurveyPatients';
import LaunchIcon from '@material-ui/icons/Launch';

const ListSurveyPatientsActions = ({ data, Callback }) => {

    const [openModal, setOpenModal] = React.useState(false);

    useEffect(() => {
    }, []);

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Ver Encuesta">
                <IconButton style={{ fontSize: '15px' }} onClick={() => {
                    setOpenModal(true);
                }}>
                       <LaunchIcon />
                </IconButton>
            </Tooltip>
        </td>

        <ModalSurveyPatients
            opened={openModal}
            closeModal={() => {
                setOpenModal(false);
            }}
            data={data.data.original}
        />
    </Fragment>)
}

export default ListSurveyPatientsActions;